import api from "./api";

interface SidebarProjectMoveParams {
  project_id: string;
  from_folder_id: string | null;
  to_folder_id: string | null;
  sort_detail: {
    id: string;
    sort_order: number;
  }[];
}

interface SidebarProjectMoveProps {
  projectId: string;
  toFolderId: string | null;
  sortDetail: {
    id: string;
    sortOrder: number;
  }[];
}

// 项目移动
export const sidebarProjectMove = async (props: SidebarProjectMoveProps) => {
  const params: SidebarProjectMoveParams = {
    project_id: props.projectId,
    from_folder_id: null,
    to_folder_id: props.toFolderId,
    sort_detail: props.sortDetail.map(item => ({
      id: item.id,
      sort_order: item.sortOrder,
    })),
  };
  const res = await api.post<unknown>("/sidebar/project/move", params);
  return res;
};
